import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface RollTextProps {
    text: string
    className?: string
    stagger?: number
}

export const RollText: FC<RollTextProps> = ({ text, className, stagger = 0.015 }): ReactNode => {
    const chars = Array.from(text)

    return (
        <span className={cn('relative inline-block overflow-hidden whitespace-nowrap align-top', className)}>
            <span className='sr-only'>
                {text}
            </span>

            <span aria-hidden='true' className='relative inline-block min-w-max'>
                <span className='block'>
                    {chars.map((char, index) => (
                        <span
                            key={`a-${index}`}
                            className='roll-char'
                            style={{ transitionDelay: `${(index * stagger).toFixed(3)}s` }}
                        >
                            {char}
                        </span>
                    ))}
                </span>

                <span className='pointer-events-none absolute left-0 top-0 block'>
                    {chars.map((char, index) => (
                        <span
                            key={`b-${index}`}
                            className='roll-char-alt'
                            style={{ transitionDelay: `${(index * stagger).toFixed(3)}s` }}
                        >
                            {char}
                        </span>
                    ))}
                </span>
            </span>
        </span>
    )
}
